import script from "./Best.vue?vue&type=script&setup=true&lang=ts"
export * from "./Best.vue?vue&type=script&setup=true&lang=ts"

import "./Best.vue?vue&type=style&index=0&id=71112b60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71112b60"]])

export default __exports__